export const TOOLKIT_GRID_COLLAPSED_ROW_COUNT = 2;

export function getToolkitGridColumnCount(containerWidth: number, compact: boolean): number {
  if (compact) {
    if (containerWidth >= 770) return 3;
    if (containerWidth >= 570) return 2;
    return 1;
  }

  if (containerWidth >= 1100) return 4;
  if (containerWidth >= 900) return 3;
  if (containerWidth >= 550) return 2;
  return 1;
}

export function getToolkitGridCollapsedLimit(containerWidth: number, compact: boolean): number {
  return getToolkitGridColumnCount(containerWidth, compact) * TOOLKIT_GRID_COLLAPSED_ROW_COUNT;
}
